// Utilitaires + petits composants partages du catalogue Paniers (tournees, client).
// Fidele prototype v5 (§5 — vignettes producteurs, multi-offres, rayons).

const ORANGE = 'rgb(var(--c-primary))'
const TEAL = 'rgb(var(--c-teal))'
const VERT = 'rgb(var(--c-green))'

// Palette deterministe pour les pastilles producteurs (pas de couleur cote API).
const PALETTE = ['rgb(var(--c-teal))', 'rgb(var(--c-primary))', 'rgb(var(--c-indigo))', '#0d6b5f', '#b06a43', '#d99a2b']

export { ORANGE, TEAL, VERT }

export const formatPrix = (n) => `${Number(n).toFixed(2).replace('.', ',')} €`

/** Initiales (1-2 lettres, sans accents) d'un nom de producteur. Ex: "Ferme Bele" -> "FB". */
export function initials(nom = '') {
  const words = nom
    .normalize('NFD')
    .replace(/[^\x00-\x7F]/g, "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
  if (words.length === 0) return '??'
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase()
  return (words[0][0] + words[1][0]).toUpperCase()
}

/** Couleur stable derivee d'une graine (id ou nom producteur). */
export function colorFor(seed = '') {
  let h = 0
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0
  return PALETTE[h % PALETTE.length]
}

/** Producteurs uniques (par id) derriere un produit, depuis ses offres. */
export function producersOf(p) {
  const map = new Map()
  ;(p.offres || []).forEach((o) => {
    const pr = o.producteur
    if (pr && !map.has(pr.id)) map.set(pr.id, pr)
  })
  return [...map.values()]
}

/** Offre la moins chere encore disponible (attribution auto « meilleur prix », §5). */
export function cheapestOffer(p) {
  return (p.offres || [])
    .filter((o) => Number(o.quantiteRestante) > 0)
    .sort((a, b) => Number(a.prix) - Number(b.prix))[0]
}

/** Rayons presents dans le catalogue (+ « Tout » en tete), ordre alpha FR. */
export function deriveRayons(produits) {
  const map = new Map()
  produits.forEach((p) => {
    const cat = p.product?.category
    const nom = cat?.nom || 'Autres'
    if (!map.has(nom)) map.set(nom, cat?.emoji || '🧺')
  })
  const list = [...map.entries()]
    .sort((a, b) => a[0].localeCompare(b[0], 'fr'))
    .map(([n, e]) => ({ n, e }))
  return [{ n: 'Tout', e: '✨' }, ...list]
}

/** Rayon (categorie) d'un produit. */
export const rayonOf = (p) => p.product?.category?.nom || 'Autres'

/**
 * Pastilles producteurs empilees (avatars) — fidele prototype v5.
 * @param producers liste { id, nom }
 */
export function Avatars({ producers = [], size = 19, muted = 'rgba(7,62,61,0.5)' }) {
  const shown = producers.slice(0, 3)
  const extra = producers.length - shown.length
  if (shown.length === 0) return null
  return (
    <div className="flex items-center">
      {shown.map((pr, i) => (
        <span
          key={pr.id || pr.nom}
          title={pr.nom}
          className="rounded-full flex items-center justify-center font-extrabold text-creme flex-shrink-0"
          style={{
            width: size,
            height: size,
            fontSize: size * 0.42,
            letterSpacing: 0.3,
            background: colorFor(pr.id || pr.nom),
            border: '1.5px solid rgba(255,255,255,0.95)',
            marginLeft: i === 0 ? 0 : -size * 0.32,
            boxShadow: '0 2px 6px rgba(7,62,61,0.18)',
          }}
        >
          {initials(pr.nom)}
        </span>
      ))}
      {extra > 0 && (
        <span className="ml-1.5 text-[10px] font-bold" style={{ color: muted }}>+{extra}</span>
      )}
    </div>
  )
}

/**
 * Bandeau tournee en cours (fidele prototype v5 — TourneeBar) : point pulse, date
 * de livraison, deadline de commande, badge OUVERTE.
 */
export function TourneeBar({ tour, formatDate }) {
  const cloture = tour?.dateClotureCommandes || tour?.dateLivraison
  return (
    <div className="glass-dark rounded-2xl px-3.5 py-2.5 mb-3 flex items-center gap-2.5 relative z-[3]" style={{ color: 'rgb(var(--c-creme))' }}>
      <span className="w-2 h-2 rounded-full flex-shrink-0 animate-pulse" style={{ background: TEAL }} />
      <div className="flex-1 min-w-0">
        <p className="text-[12.5px] font-bold truncate">{tour?.nom || (tour?.dateLivraison ? `Tournée du ${formatDate(tour.dateLivraison)}` : 'Tournée')}</p>
        <p className="text-[11px]" style={{ color: 'rgba(247,240,234,0.7)' }}>
          {cloture ? `Commandez avant le ${formatDate(cloture)}` : 'Commandes ouvertes'}
        </p>
      </div>
      <span className="text-[10px] font-bold tracking-wide px-2.5 py-1 rounded-full flex-shrink-0" style={{ background: ORANGE, color: VERT }}>OUVERTE</span>
    </div>
  )
}
